import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash || window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/admin-momento-secure-2024");
        return;
      }
      const sessionId = match[1];

      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        // Store session_token as backup for cross-origin scenarios
        if (res.data.session_token) {
          sessionStorage.setItem("momento_google_token", res.data.session_token);
        }
        // Clear hash and navigate
        window.history.replaceState({}, "", "/admin-momento-secure-2024");
        navigate("/admin-momento-secure-2024", { state: { user: res.data } });
      } catch (err) {
        const detail = err.response?.data?.detail || "Authentication failed";
        alert(detail);
        navigate("/admin-momento-secure-2024");
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center" dir="rtl">
      <div className="text-center">
        <div className="animate-spin w-12 h-12 border-4 border-[#C5A45A] border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-[#0F172A]">מתחברים...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
